// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .wrapper--l4OWK {
  margin-top: 20px;
}

[dir=ltr] .locationPageWrapper--EK6Ag {
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .locationPageWrapper--EK6Ag {
  margin-right: 0;
  margin-left: 0;
}

[dir=ltr] .flagIcon--O81ki {
  margin-left: 10px;
}

[dir=rtl] .flagIcon--O81ki {
  margin-right: 10px;
}

[dir=ltr] .infoIcon--J8PCK {
  margin-left: 5px;
}

[dir=rtl] .infoIcon--J8PCK {
  margin-right: 5px;
}

[dir=ltr] .chartInfoIcon--dXeYW {
  float: right;
  margin-right: 10px;
}

[dir=rtl] .chartInfoIcon--dXeYW {
  float: left;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OverviewSingleLocationSingleSubject/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAHA;EACE,eAAc;EACd,cAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,kBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,iBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAHA;EACE,WAAY;EACZ,iBAAkB;AACpB","sourcesContent":[".wrapper {\n  margin-top: 20px;\n}\n\n.locationPageWrapper {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.flagIcon {\n  margin-left: 10px;\n}\n\n.infoIcon {\n  margin-left: 5px;\n}\n\n.chartInfoIcon {\n  float: right;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper--l4OWK`,
	"locationPageWrapper": `locationPageWrapper--EK6Ag`,
	"flagIcon": `flagIcon--O81ki`,
	"infoIcon": `infoIcon--J8PCK`,
	"chartInfoIcon": `chartInfoIcon--dXeYW`
};
export default ___CSS_LOADER_EXPORT___;
